import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {NavItem} from "libComm";

@Injectable()
export class NavService
{
	public appDrawer: any;
	public currentUrl : BehaviorSubject<string> = new BehaviorSubject<string>('');
	public selectedItem?: NavItem;

	constructor(private router: Router)
	{
		this.router.events.subscribe((event: any) =>
		{
			if (event instanceof NavigationEnd)
			{
				this.currentUrl.next(event.urlAfterRedirects);
			}
		});
	}

	public closeNav()
	{
		this.appDrawer.toggle();
	}

	public openNav()
	{
		this.appDrawer.toggle();
	}
}
